import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import useBrowserMode from '../../../hooks/useBrowserMode';
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import tenaLogo from './../../../assets/images/logo-tena.svg';
import LightBox from './../../organisms/lightbox/lightbox';
import './logo.scss';

const Logo = (props) => {

    const lightBoxUsage = "countriesList";
    const node = useRef();
    const selectTitle = 'Cambia de país';
    const currentCountry = props.countriesData ? props.countriesData.currentCountry : 'CO';
    const [listOpen, setCountriesState] = useState(false);
    const { homeLink } = useHomeLinkMode();
    const { isBrowser } = useBrowserMode();
    const [fCloseClass, setClass] = useState('');

    const openHideDropdown = () => {
        if (listOpen === false) {
            setCountriesState(true);
        } else {
            setClass('f-closed-dropdown');
            setTimeout(() => {
                setCountriesState(false);
                setClass('');
            }, 200);
        }
    };

    const handleClickOutside = e => {
        if (node.current.contains(e.target)) {
            return;
        }
        setClass('f-closed-dropdown');
        setTimeout(() => {
            setCountriesState(false);
            setClass('');
        }, 500);
    };

    useEffect(() => {
        if (listOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [listOpen]);

    return (
        <div className="f-logo-container">
            {isBrowser &&
                <a href={props.adviserActive ? props.adviserActive() ? homeLink + 'callcenter' : homeLink : homeLink} >
                    <img src={tenaLogo} alt="Logo TENA"/>
                </a>
            }
            <div className="f-select-container">
                <span className="f-select-title">{currentCountry}</span>
                <div className="f-select-wrapper">
                    <p ref={node} onClick={openHideDropdown}>{selectTitle}</p>
                </div>
                {listOpen && <LightBox classToAdd={fCloseClass} lightBoxUsage={lightBoxUsage} countriesData={props.countriesData} />}
            </div>
        </div>
    )
};

Logo.propTypes = {
    name: PropTypes.string
};

export default Logo;
